import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

type StatusAutoReplyProps = {
  date: string;
  templateName: string | null;
};

export class StatusAutoReply extends PureComponent<StatusAutoReplyProps> {
  generateStatusText() {
    const { templateName } = this.props;

    const text = 'Autoreply sent';

    if (templateName) {
      return `${text} with template ${templateName}`;
    }
    return text;
  }

  render() {
    const { date, ...otherProps } = this.props;

    return (
      <MessageStatus
        {...otherProps}
        date={date}
        text={this.generateStatusText()}
      />
    );
  }
}
